import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ClientSecondary" }

import { PropType, computed } from "vue";
import { Client } from "@/types";
import InnForm from "@/components/ds/form/Form.vue";
import languages from "@/data/languages";
import { useCompanyStore } from "@/stores/company";


export default /*#__PURE__*/_defineComponent({
  __name: 'ClientSecondary',
  props: {
    client: {
        type: Object as PropType<Client>,
        required: true,
    },
},
  setup(__props) {



const companyStore = useCompanyStore();

const config = computed(() => {
    const acumulsSection = {
        items: [
            {
                type: "number",
                key: "acumulus_client_id",
                label: "Acumulus klantnummer",
            },
        ],
    };
    const c = {
        sections: [
            {
                items: [
                    {
                        type: "checkbox",
                        key: "international",
                        label: "Internationale klant",
                    },
                    {
                        type: "checkbox",
                        key: "eu",
                        label: "Binnen de EU",
                    },
                    {
                        type: "select",
                        key: "language",
                        label: "Taal",
                        options: languages,
                        valueKey: "isoCode",
                        labelKey: "title",
                    },
                ],
            },
        ],
    };
    if (companyStore.company?.usesAcumulus) {
        c.sections.push(acumulsSection);
    }
    return c;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(InnForm, {
      config: config.value,
      value: __props.client
    }, null, 8, ["config", "value"])
  ]))
}
}

})